// Y-axis display range for the menu-test products chart, ported from block.coffee
// getDisplayRange off the sh lib/display-range.js template (D11). The rendered chart answers
// first (hook-level getAxisExtremes), and this maths is the fallback for an unrendered chart.
//
// No live consumer yet — pptx getMenuTestParams doesn't request a displayRange — kept
// sh-parity-ready for exports.

import { round } from '@aytm/app/stats/lib/util/helpers'
import { getErrData } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/errData'
import { calcIgnoreAmount, calcIgnorePercents } from '@aytm/app/stats/page/question-views/components/lib/chart-modes'

// mn has no pie guard: both mn getDefaultChartMode overrides convert pie away, so a resolved
// mode never lands on it (unlike sh)
const NON_RANGE_CHART_MODES = ['none']

export const calcDisplayRange = ({
  chartMode,
  zoomLevel,
  globalChartMode,
  viewMode,
  format = {},
  answer = {},
  trait,
  isTraitType,
  ignoreAmount: ignoreAmountFlag,
  ignorePercents: ignorePercentsFlag,
  confidenceLevels = []
} = {}) => {
  if (trait && isTraitType) return null
  if (NON_RANGE_CHART_MODES.includes(chartMode) || NON_RANGE_CHART_MODES.includes(globalChartMode)) return null

  if (!['min', 'max'].includes(zoomLevel)) return zoomLevel ?? null

  const percentsMode = String(chartMode ?? '').endsWith('percents')
  const mode = percentsMode ? 'percents' : 'amount'

  const ignoreAmount = calcIgnoreAmount(format, ignoreAmountFlag)
  const ignorePercents = calcIgnorePercents(format, ignorePercentsFlag)

  let min = 0
  let max = 0

  for (const [answerKey, answerValue] of Object.entries(answer)) {
    if ('a' !== answerKey[0] || Number.isNaN(Number(answerKey.slice(1)))) continue

    if ('amount' === viewMode) {
      const { maxErrValue } = getErrData(answerValue, mode, {
        ignoreAmount,
        ignorePercents,
        rType: 'cases',
        answerType: 'amount',
        confidenceLevels
      })

      max = Math.max(
        max,
        parseFloat((percentsMode ? answerValue.percents : answerValue.amount) || 0) + (maxErrValue || 0)
      )
      continue
    }

    min = Math.min(min, parseFloat(answerValue[viewMode] || 0))
    max = Math.max(max, parseFloat(answerValue[viewMode] || 0))
  }

  if ('amount' !== viewMode) {
    min = 0 > min ? -Math.ceil(Math.abs(min)) : 0
    max = 0 >= max && 0 <= min ? 100 : 0 >= max ? Math.ceil(Math.abs(min)) : Math.ceil(max)
  }

  min = 0 > min ? -Math.ceil(Math.abs(min)) : Math.floor(min)
  max = Math.ceil(max)

  if ('max' === zoomLevel) {
    if ('amount' === viewMode) return percentsMode ? [0, 100] : [0, answer.total || 0]

    // a flat series has no range to pin; the coffee blocks answered false here and the exporters
    // read that as "no limits", so it is kept rather than turned into a null
    return min !== max ? [round(min, 2), round(max, 2)] : false
  }

  return [min, max]
}
